module.exports = function timeDifference(current, previous) {
  let msPerMinute = 60 * 1000;
  let msPerHour = msPerMinute * 60;
  let msPerDay = msPerHour * 24;
  let msPerMonth = msPerDay * 30;
  let msPerYear = msPerDay * 365;
 
  let elapsed = current - previous;

  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + " secs ago";
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + " mins ago";
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + " hrs ago";
  } else if (elapsed < msPerMonth) {
    return Math.round(elapsed / msPerDay) + " days ago";
  } else if (elapsed < msPerYear) {
    return Math.round(elapsed / msPerMonth) + " months ago";
  } else {
    return Math.round(elapsed / msPerYear) + " years ago";
  }
};

//new Date('2019-11-18T08:10:58.235Z');
// 2019-11-18T08:10:58.235Z
